<div *ngIf="(loadedState$ | async) as loadedState">
	<ng-container [ngSwitch]="loadedState">
		<ngx-zero-state class="loading-indicator-zero-state ng-animate-disabled" *ngSwitchCase="LoadingState.LOADING">
			<p zero-state-title>
				<span translate="activity-view_reports-loading-indicator-title"></span>
			</p>
			<p zero-state-subtext>
				<span translate="activity-view_sessions-loading-indicator-subtext"></span>
			</p>
			<p zero-state-body>
				<span class="loading-indicator-icon ficon-spinner ficon-spin"></span>
			</p>
		</ngx-zero-state>
		
		<ngx-zero-state class="error-zero-state" *ngSwitchCase="LoadingState.ERROR">
			<p zero-state-title>
				<span translate="activity-report-panel_activity-report-unavailable"></span>
			</p>
			<p zero-state-subtext>
				<span translate="activity-report-panel_activity-report-unavailable-subtext"></span>
			</p>
			<p zero-state-body>
				<a
					class="tertiary-btn"
					target="_blank"
					[href]="helpUrls.instructorSupport"
					[attr.aria-label]="'activity-report-panel_activity-report-unavailable-support' | translate"
					translate="activity-report-panel_activity-report-unavailable-support">
				</a>
			</p>
		</ngx-zero-state>
		
		<section class="course-report" *ngSwitchCase="LoadingState.LOADED">
			<header class="course-report-header">
				<p class="header-cell align-left" translate="common_user"></p>
				<p class="header-cell" translate="activity-report_controller-videos-critiqued"></p>
				<p class="header-cell" translate="activity-report_controller-total-comments"></p>
				<p class="header-cell" translate="activity-report_controller-avg-comment-length"></p>
				<p class="header-cell" translate="activity-report_controller-video-presented"></p>
				<p class="header-cell" translate="activity-report_controller-total-score"></p>
				<p class="header-cell" translate="activity-report_controller-markers"></p>
			</header>
			<section class="user-list">
				<section class="user-report">
					<section class="user-stats" *ngFor="let user of summarizedReport">
						<header class="user-stats-header">
							<section class="expand-name">
								<button
									type="button"
									[attr.aria-label]="'activity-report_controller-user-details-label' | translate: {state: (user.expanded ? 'collapse' : 'expand')}"
									[attr.aria-expanded]="user.expanded"
									(click)="toggleUser(user)"
									data-cy="activity-report-expand-user"
									class="toggle-report-button">
									<i class="ficon-app-chevron-down" [ngClass]="{'flipped': user.expanded}"></i>
								</button>
								<p
									class="body-cell align-left"
									[attr.aria-label]="'activity-report_controller-user-label' | translate: {lastName: user.last_name, firstName: user.first_name}"
									tabindex="0">
									{{user.last_name}}, {{user.first_name}}
								</p>
							</section>
							<p
								class="body-cell"
								[attr.aria-label]="'activity-report_controller-videos-critiqued-stat' | translate: {stat: (user.num_videos_reviewed || 'blank')}"
								tabindex="0">
								{{user.num_videos_reviewed}}
							</p>
							<p
								class="body-cell"
								[attr.aria-label]="'activity-report_controller-total-comments-stat' | translate: {stat: (user.num_comments || 'blank')}"
								tabindex="0">
								{{user.num_comments}}
							</p>
							<p
								class="body-cell"
								[attr.aria-label]="'activity-report_controller-avg-comment-length-stat' | translate: {stat: (user.avg_comment_length || 'blank')}"
								tabindex="0">
								{{user.avg_comment_length}}
							</p>
							<p
								class="body-cell"
								[attr.aria-label]="'activity-report_controller-video-presented-stat' | translate: {stat: (user.num_videos_presented || 'blank')}"
								tabindex="0">
								{{user.num_videos_presented}}
							</p>
							<p
								class="body-cell"
								[attr.aria-label]="'activity-report_controller-total-score-stat' | translate: {stat: (user.total_score || 'blank')}"
								tabindex="0">
								{{user.total_score}}
							</p>
							<section
								class="stats-markers"
								[attr.aria-label]="'activity-report_controller-markers-stat' | translate: {stat: (user.marker_counts.length ? '' : 'blank')}"
								tabindex="{{user.marker_counts.length ? -1 : 0 }}">
								<marker-display [markers]="user.marker_counts" [withCount]="true"></marker-display>
							</section>
						</header>
						<p
							class="no-sessions-message"
							*ngIf="user.expanded && userReports[user.user_id] === null"
							translate="activity-report_controller-no-sessions-to-show"
							[attr.aria-label]="'activity-report_controller-no-sessions-to-show' | translate"
							tabindex="0">
						</p>
						<table class="stats-table" *ngIf="user.expanded && userReports[user.user_id]">
							<thead>
								<tr>
									<th translate="activity-report_controller-presenters"></th>
									<th translate="activity-report_controller-activity"></th>
									<th translate="activity-report_controller-session-id"></th>
									<th translate="activity-report_controller-date"></th>
									<th translate="activity-report_controller-duration"></th>
									<th translate="activity-report_controller-final-score"></th>
									<th translate="activity-report_controller-markers"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let session of userReports[user.user_id]">
									<td
										class="user-stats-presenters"
										[attr.aria-label]="'activity-report_controller-presenters-label' | translate"
										tabindex="0">
										<span
											*ngFor="let presenter of session.presenters; let isLast = last"
											attr.aria-label="{{presenter.last_name}}, {{presenter.first_name}}">
											{{presenter.last_name}}, {{presenter.first_name}}<span *ngIf="!isLast">&nbsp;&bull;&nbsp;</span>
										</span>
									</td>
									<td [attr.aria-label]="'activity-report_controller-assignment' | translate" tabindex="0">
										{{session.activity.name}}
									</td>
									<td [attr.aria-label]="'activity-report_controller-session-id' | translate" tabindex="0">
										{{session.session_id}}
									</td>
									<td [attr.aria-label]="'activity-report_controller-date' | translate" tabindex="0">
										{{session.started_at | date:'short'}}
									</td>
									<td [attr.aria-label]="'activity-report_controller-duration' | translate" tabindex="0">
										{{session.duration | formatTime}}
									</td>
									<td [attr.aria-label]="'activity-report_controller-final-score' | translate" tabindex="0">
										{{session.total_score}}
									</td>
									<td tabindex="{{session.marker_counts.length ? -1 : 0 }}">
										<marker-display [markers]="session.marker_counts" [withCount]="true"></marker-display>
									</td>
								</tr>
							</tbody>
						</table>
					</section>
				</section>
			</section>
		</section>
	</ng-container>
</div>
